export const version = "transactions/5.0.8";
//# sourceMappingURL=_version.js.map